import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { MobileMenu } from "features/shell";
import HomeLanding from "./HomeLanding/HomeLanding";

import { getCookie } from "shared/auth/utils/cookieUtils";
import { defaultHomeLandingModel } from "./HomeLanding/defaultHomeLandingModel";

const normalizeRole = (
  raw: string | null | undefined
): "USER" | "CREATOR" | "CURATOR" | "ADMIN" | null => {
  if (!raw) return null;
  const value = raw.trim().toUpperCase();
  if (value === "USER") return "USER";
  if (value === "CREATOR") return "CREATOR";
  if (value === "CURATOR") return "CURATOR";
  if (value === "ADMIN") return "ADMIN";
  return null;
};

const MobileHome: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const normalizedRole = normalizeRole(getCookie("userRole") || "");

  if (normalizedRole !== "USER" && normalizedRole !== "CURATOR") {
    return <Navigate to="/mobile/pair_headset" replace />;
  }

  return (
    <div className="menu-component-mobile">
      <div className="main-container-home-mobile mobile-home-wrapper">
        <div className="menu-home menu-component-header-mobile">
          <img
            src="/images/poetics-stream-lockup.svg"
            alt="Poetics Stream"
            className="quima-logo-mobile"
          />
          <img
            src="/images/mobile/hamburger-menu.svg"
            alt="menu"
            className="quima-menu-btn-mobile"
            onClick={() => setIsMenuOpen((o) => !o)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === "Enter" || e.key === " ") setIsMenuOpen((o) => !o);
            }}
          />
        </div>
        <div className="mobile-home-landing-scroll">
          <HomeLanding model={defaultHomeLandingModel} />
        </div>
      </div>
      {isMenuOpen && (
        <MobileMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
      )}
    </div>
  );
};

export default MobileHome;